import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface UsePageTitleOptions {
  title?: string;
  prefix?: string;
  suffix?: string;
}

export const usePageTitle = ({ title, prefix, suffix }: UsePageTitleOptions = {}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (title) {
      const translatedTitle = t(title);
      const fullTitle = [prefix, translatedTitle, suffix].filter(Boolean).join(' - ');
      document.title = fullTitle;
    }
  }, [title, prefix, suffix, t]);

  const setTitle = (newTitle: string) => {
    const translatedTitle = t(newTitle);
    const fullTitle = [prefix, translatedTitle, suffix].filter(Boolean).join(' - ');
    document.title = fullTitle;
  };

  return { setTitle };
};

export default usePageTitle;
